import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './actions';
import type {VisitorsSidebarAction} from './actions';

export type VisitorsSidebarState = {
    isOpen: boolean;
    visitorId: string | null | undefined;
};

export const defaultVisitorsSidebarState = {
    isOpen: false,
    visitorId: null,
} as const;

export const visitorsSidebarReducer = (
    state: VisitorsSidebarState | null | undefined = defaultVisitorsSidebarState,
    action: VisitorsSidebarAction
): VisitorsSidebarState => {
    switch (action.type) {
        case ActionTypes.VISITORS_SIDEBAR_OPENED:
            return {
                ...state,
                isOpen: true,
                visitorId: action.payload.visitorId,
            };
        case ActionTypes.VISITORS_SIDEBAR_CLOSED:
            return defaultVisitorsSidebarState;
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            const persistedState = action.payload;
            if (!persistedState || !persistedState.ui || !persistedState.ui.visitorSidebar) {
                // @ts-expect-error
                return state;
            }

            return persistedState.ui.visitorsSidebar;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
